import { hashHistory } from "config/history";
import { defaultHashRoute, hashRoutes } from "constants/routes";

const goToHash = (path: string) => {
    if (path === "") {
        // Normally, navigating to an empty hash scrolls the current page to top
        // Work around this with non-existing hash (#_) to close any open hash paths,
        // and then use the browsers own API to replace the state to one without any has
        // so router won't get triggered.
        hashHistory.push(defaultHashRoute);
        window.history.replaceState(
            {},
            "modal-close",
            `${window.location.pathname + window.location.search}#`,
        );
    } else {
        hashHistory.push(path);
    }
};


function onOpenContentItem(id: string) {
    goToHash(`/${hashRoutes.contentItem}/${id}`);
}

export { goToHash, onOpenContentItem };
